import React, { FC } from 'react';
import ForceGameStateChange from '../../mutations/ForceGameStateChange';
import './styles.scss';
import lockIcon from './lock.svg';
import unlockIcon from './unlock.svg';
import Tooltip from '../Tooltip';

interface ActivateDisableGameButtonProps {
  gameID: string;
  status: 'activateGame' | 'disableGame';
}

export const ActivateDisableGameButton: FC<ActivateDisableGameButtonProps> = (props) => {
  
  const onClick = (mutation: Function) => {
    mutation({
      variables: {
        gameID: props.gameID,
        forceActivation: props.status === 'activateGame' ? true : false
      }
    })
  } 
  
  return (
    <ForceGameStateChange>
      {(mutation: Function) => (
        <>
          <img 
            src={
              props.status === 'activateGame'
                ? unlockIcon
                : lockIcon 
            }
            style={{
              width: '20px',
              height: '20px',
              margin: '0 10px',
              cursor: 'pointer'
            }}
            onClick={() => onClick(mutation)}
          />
        </>
      )}
    </ForceGameStateChange>
)};
